import { motion } from "framer-motion";
import type { PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

type Props = {
  active: boolean;
  dotColor?: string;
};

const NavbarItemIcon = ({
  children,
  active,
  dotColor,
}: PropsWithChildren<Props>) => {
  return (
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      {dotColor && (
        <div
          className={cn(
            "absolute -top-2 left-full h-2 w-2 rounded-full",
            dotColor,
          )}
        ></div>
      )}

      <motion.div
        className="text-customWhite"
        initial={{ y: 20 }}
        animate={{
          y: active ? -7.5 : 0,
          opacity: active ? 1 : 0.8,
        }}
        transition={{ duration: 0.1 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default NavbarItemIcon;
